import React, { Component } from 'react';
import { NavBar, TimeOut, BreadCumb } from '../../components';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { connect } from 'react-redux';
import config from '../../config';
import moment from 'moment';
import { ApiClient } from '../../libs/apiClient';
import '../../css/tablesPOS.css';
let apiClient = ApiClient.getInstance();

class PromotionManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            itemsDashboard: JSON.parse(localStorage.getItem(config.localStorageNamed + 'itemsDashboard')),
            startTime: '',
            endTime: '',
            day: '',
            promotions: [],
            authorizations: [],
            isVisible: false,
            selectAllAuthorizations:false,
        }
    }

    componentDidMount = async () => {
        this._handelBack();
        await this.getPromos();
        await this.getAuthorizations();
    }
    getPromos = async () => {
        const { enableSpinner } = this.props;
        enableSpinner(true);
        let response = await apiClient.getPromosActive();
        enableSpinner(false);
        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                promotions: response.data
            })
        }
    }

    getAuthorizations = async () => {
        const { enableSpinner } = this.props;
        enableSpinner(true);
        let response = await apiClient.getAuthorizations();
        enableSpinner(false);
        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                authorizations: response?.data ?? []
            })
        }
    }

    _handelBack = () => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () { window.location.hash = "no-back-button"; }
    };

    onChangeInputs = (e, index) => {
        const { name, value } = e.target;
        const { promotions } = this.state
        const auxPromos = promotions.slice()
        auxPromos[index][name] = value
        this.setState({ promotions: auxPromos });
    };
    sendPromo = async () => {
        const {promotions, authorizations} = this.state
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        await apiClient.savePromos(promotions,authorizations);
        enableSpinner(false);
        showAlert({ type: 'success', message: `Datos Guardados`, timeOut: 4000 });
        return
    }

    handleSubmit = (e) => {
        const { notificationReducer: { showAlert } } = this.props
        e.preventDefault();
        let continueProcess = true
        this.state.promotions.forEach((promo, index) => {
            const startDate = new Date(promo.InitDate);
            const endDate = new Date(promo.EndDate);

            if (endDate < startDate) {
                showAlert({ type: 'warning', message: `La fecha de fin no puede ser anterior a la fecha de inicio en la promoción ${index + 1}.`, timeOut: 4000 });
                continueProcess = false
                return
            }

            if (endDate.getTime() === startDate.getTime()) {
                const [startHour, startMinute] = promo.InitTime.split(":");
                const [endHour, endMinute] = promo.EndTime.split(":");

                const startTime = new Date();
                startTime.setHours(startHour, startMinute);

                const endTime = new Date();
                endTime.setHours(endHour, endMinute);

                if (endTime < startTime) {
                    showAlert({ type: 'warning', message: `La hora de fin no puede ser anterior a la hora de inicio en la promoción ${index + 1}.`, timeOut: 4000 });
                    continueProcess = false
                    return
                }
            }
        });
        if(continueProcess){
            this.sendPromo();
        }
    }

    onChangeAuth = ( code, index) => {
        const { authorizations } = this.state
        const auxAuthorizations = authorizations.slice();
        if (auxAuthorizations[index] && auxAuthorizations[index].WtmCode === code) {
            auxAuthorizations[index].Active = auxAuthorizations[index].Active  === 'Y' ? 'N':'Y'
            
            this.setState({
                authorizations: auxAuthorizations
            })

        }
    }
    showAuthorizations = () => {
        this.setState({
            isVisible: !this.state.isVisible,
        })
    }
    selectAllAuthorizations =()=>{
        const {selectAllAuthorizations} = this.state
        const {authorizations} = this.state
        const auxAuthorizations = authorizations.slice();
        for (let index = 0; index < auxAuthorizations.length; index++) {
            const auth = auxAuthorizations[index];
            auth.Active = selectAllAuthorizations ? 'N':'Y'
        }
        this.setState({
            authorizations:auxAuthorizations,
            selectAllAuthorizations:!selectAllAuthorizations,
        })
    }

    render() {
        const { itemsDashboard, _user, startTime, endTime, day, promotions } = this.state
        return (
            <div className="content">
                <NavBar props={this.props} itemsDashboard={itemsDashboard} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'HORARIOS'} url1={'#'} />
                <div style={{ marginLeft: "5.5rem", marginRight: "1rem" }}>
                    <div className="row mb-3">
                        <h3 className="col-12">ADMINISTRADOR DE HORARIOS</h3>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            {promotions.map((promo, index) => (
                                <div className='col-12 d-block'>
                                    <div className="row mb-3 align-items-center" key={index} style={{ display: 'flex', flexWrap: 'wrap' }}>
                                        <div className="col-md-12 mb-2">
                                            <h5>{this.renderTitle(promo.Type)}</h5>
                                        </div>
                                        <div className="col-md-3 mb-2">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text"><strong>F. Inicio</strong></span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    type="date"
                                                    value={promo.InitDate}
                                                    name="InitDate"
                                                    onChange={(e) => this.onChangeInputs(e, index)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3 mb-2">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text"><strong>F. Fin</strong></span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    type="date"
                                                    value={promo.EndDate}
                                                    name="EndDate"
                                                    onChange={(e) => this.onChangeInputs(e, index)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3 mb-2">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text"><strong>Hora de inicio</strong></span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    type="time"
                                                    value={promo.InitTime}
                                                    name="InitTime"
                                                    onChange={(e) => this.onChangeInputs(e, index)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3 mb-2">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text"><strong>Hora de fin</strong></span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    type="time"
                                                    value={promo.EndTime}
                                                    name="EndTime"
                                                    onChange={(e) => this.onChangeInputs(e, index)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {this.renderOptions(promo.Type)}

                                </div>

                            ))}
                            <div className="row mb-3">
                                <div className="col-12 d-flex justify-content-end">
                                    <button type="submit" className="btn btn-primary" onClick={this.handleSubmit}>
                                        <i className="fa fa-save mr-2" aria-hidden="true"></i>Guardar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
    renderOptions = type => {
        switch (type) {
            case 'A':
                return this.renderAuthorizations()

            default:
                break;
        }
    }
    renderTitle = type => {
        switch (type) {
            case 'S'://SPECIAL PRICES
                return 'Precios Especiales'
            case 'A'://Authorizaciones
                return 'Autorizaciones'
            default:
                break;
        }
    }

    renderAuthorizations = () => {
        const { authorizations, isVisible,selectAllAuthorizations } = this.state
        return (
            <>
                <div className='d-flex justify-content-end align-items-end'>
                    <button
                        className="btn btn-light mb-3"
                        onClick={this.showAuthorizations}
                        style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
                        title={isVisible ? 'Ocultar autorizaciones' : 'Mostrar autorizaciones'}
                    >
                        {isVisible ? (
                            <span style={{ fontSize: '15px' }}>&#9650;</span> // ▲ Flecha hacia arriba
                        ) : (
                            <span style={{ fontSize: '15px' }}>&#9660;</span> // ▼ Flecha hacia abajo
                        )}
                    </button>
                </div>
                {isVisible && ( // Mostrar el checkbox solo si las autorizaciones están visibles
                    <div className="d-flex justify-content-end align-items-center ms-2"> {/* Espaciado */}
                        <input
                            type="checkbox"
                            id="selectAllAuthorizations"
                            checked={selectAllAuthorizations}
                            onChange={this.selectAllAuthorizations} // Manejar el evento de selección
                            style={{ marginRight: '5px' }} // Espaciado entre el checkbox y el texto
                        />
                        <label htmlFor="selectAllAuthorizations" style={{ fontSize: '15px' }}>Seleccionar todo</label>
                    </div>
                )}

                {isVisible && <div className='col-12 border border-light p-5 rounded'>
                    <div className="row">
                        {authorizations.map((auth, index) => (
                            <div className="col-md-3 mb-2 d-flex" key={index}>
                                <div className="d-flex align-items-center w-100">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text d-block text-truncate" style={{ width: '300px', whiteSpace: 'nowrap', overflow: 'hidden' }}>
                                            <strong>{auth.Name}</strong>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        type="checkbox"
                                        checked={auth.Active === 'Y'}
                                        name="authorization"
                                        onChange={() => this.onChangeAuth( auth.WtmCode, index)}
                                        style={{ height: '30px', width: '30px', minWidth: '30px', marginLeft: '10px' }}
                                        required
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>}
            </>

        )
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PromotionManagement);